import script from "./gameRounds.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameRounds.vue?vue&type=script&setup=true&lang=ts"

import "./gameRounds.vue?vue&type=style&index=0&id=4c75b240&lang=css"

const __exports__ = script;

export default __exports__